import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const MapSkeleton = () => {
    return (
        <div className="flex items-center justify-center">
            <Skeleton width={261} height={180} />
        </div>
    );
};